import React from "react";
import { moreOrLess } from "../../../utils/numbers";
import Delta from "./Delta";
import {
  TileContainer,
  Tile,
  Label,
  SubLabel,
  MetricContainer,
  Metric,
  Description,
} from "./ReportMetrics.styles";

interface Props {
  done: {
    [key: string]: { [key: string]: number };
  };
  progress: {
    outstanding: { [key: string]: number };
    active: { [key: string]: number };
    closed: { [key: string]: number };
    industryAvgActive: number;
    industryAvgClosed: number;
  };
  next: {
    [key: string]: { [key: string]: number };
  };
}
const ReportMetrics: React.FC<Props> = ({ done, progress, next }) => (
  <TileContainer>
    <Tile>
      <Label>Completed</Label>
      <SubLabel>Total number of Actions completed</SubLabel>
      <MetricContainer>
        <Metric>{done.closed.value}</Metric>
        {done.closed.delta !== 0 && (
          <Delta delta={done.closed.delta}>{Math.abs(done.closed.delta)}</Delta>
        )}
      </MetricContainer>
      {/* NOTE: Uncomment once we've got the MISSING MAGIC NUMBER */}
      <Description>
        There have been{" "}
        <strong>{`${Math.abs(done.closed.delta)} ${moreOrLess(
          done.closed.delta,
          "more",
          "less"
        )}`}</strong>{" "}
        Actions completed this month.
      </Description>
    </Tile>
    <Tile>
      <Label>Created</Label>
      <SubLabel>Total number of Actions created</SubLabel>
      <MetricContainer>
        <Metric>{done.raised.value}</Metric>
        {done.raised.delta !== 0 && (
          <Delta delta={done.raised.delta}>{Math.abs(done.raised.delta)}</Delta>
        )}
      </MetricContainer>
      <Description>
        There have been{" "}
        <strong>{`${Math.abs(done.raised.delta)} ${moreOrLess(
          done.raised.delta,
          "more",
          "less"
        )}`}</strong>{" "}
        Actions created this month.
      </Description>
    </Tile>
    <Tile>
      <Label>Average Lifespan</Label>
      <SubLabel>Average time to complete an action</SubLabel>
      <MetricContainer>
        <Metric>{progress.closed.days} days</Metric>
        {progress.closed.delta !== 0 && (
          <Delta delta={progress.closed.delta} lessIsGood>
            {Math.abs(progress.closed.delta)}
          </Delta>
        )}
      </MetricContainer>
      <Description>
        The average time taken to complete an Action is {progress.closed.days}{" "}
        days. The target for this industry is{" "}
        <strong>{progress.industryAvgClosed} days.</strong>
      </Description>
    </Tile>
    <Tile>
      <Label>Average Age</Label>
      <SubLabel>Average age of Actions in progress</SubLabel>
      <MetricContainer>
        <Metric>{progress.active.days} days</Metric>
        {progress.active.delta !== 0 && (
          <Delta delta={progress.active.delta} lessIsGood>
            {Math.abs(progress.active.delta)}
          </Delta>
        )}
      </MetricContainer>
      <Description>
        The average time that a Action is ‘in progress’ is{" "}
        {progress.active.days} days. The target for this industry is{" "}
        <strong>{progress.industryAvgActive} days.</strong>
      </Description>
    </Tile>
    <Tile>
      <Label>
        TOTAL OUTSTANDING (<em>Critical</em>)
      </Label>
      <SubLabel>
        ‘Critical’ Actions outstanding at the end of previous month
      </SubLabel>
      <MetricContainer>
        <Metric>{next.open.value}</Metric>
        {next.open.delta !== 0 && (
          <Delta delta={next.open.delta} lessIsBad>
            {Math.abs(next.open.delta)}
          </Delta>
        )}
      </MetricContainer>
      <Description>
        ‘Critical’ Actions highlight problems that most affect the performance
        of your systems and site. It’s important to complete them as soon as
        possible.
      </Description>
    </Tile>
    <Tile>
      <Label>Stagnant Actions</Label>
      <SubLabel>Actions that haven’t been completed for 60+ days</SubLabel>
      <MetricContainer>
        <Metric>{next.stagnant.value}</Metric>
        {/* NOTE: No delta available for this value yet */}
        {/* { next.stagnant.delta !== 0 && (
            <Delta delta={next.stagnant.delta}>
              {next.stagnant.delta}
            </Delta>
          ) } */}
      </MetricContainer>
      <Description>
        Actions that can’t be completed for any reason should be commented on
        with the reasons why and their status changed so they no longer show up
        in your reports.
      </Description>
    </Tile>
    <Tile>
      <Label>Pending Purchase Order</Label>
      <SubLabel>Actions that have been quoted but require a PO</SubLabel>
      <MetricContainer>
        <Metric>{next.pending.value}</Metric>
        {/* NOTE: No delta available for this value yet */}
        {/* { next.pending.delta !== 0 && (
            <Delta delta={next.pending.delta}>
              {next.pending.delta}
            </Delta>
          ) } */}
      </MetricContainer>
      <Description>
        These are Actions that can’t been worked on without a Purchase Order.
      </Description>
    </Tile>
  </TileContainer>
);

export default ReportMetrics;
